import smoothscroll from 'smoothscroll-polyfill';

smoothscroll.polyfill();

const { userAgent } = window.navigator;

if (userAgent.match(/iPad/i)) {
  document.addEventListener(
    'touchmove',
    event => {
      if (event.scale !== 1) {
        event.preventDefault();
      }
    },
    { passive: false }
  );
}
